var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-tab-pane",
    { staticClass: "no-padding", attrs: { name: "quotes" } },
    [
      _c(
        "div",
        { staticClass: "layout-padding" },
        [
          _vm.hasQuotes
            ? _c(
                "div",
                [
                  _c("q-btn", {
                    attrs: {
                      outline: "",
                      color: "primary",
                      icon: "add",
                      label: _vm.$tc("quote", 1)
                    },
                    on: { click: _vm.handleCreateQuote }
                  }),
                  _c(
                    "div",
                    { staticClass: "row gutter-sm q-mt-sm" },
                    _vm._l(_vm.quotes, function(quote) {
                      return _c(
                        "div",
                        {
                          key: quote.id,
                          staticClass: "col-xs-12 col-sm-6 col-md-4 col-xl-3"
                        },
                        [_c("quote-card", { attrs: { quote: quote } })],
                        1
                      )
                    })
                  )
                ],
                1
              )
            : [
                _c(
                  "div",
                  {
                    staticClass:
                      "row justify-center items-center col-grow q-pt-lg"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "text-center" },
                      [
                        _c("img", {
                          attrs: {
                            src: require("assets/emptystates/invoices_empty.svg"),
                            width: "40%"
                          }
                        }),
                        _c("h6", { staticClass: "q-my-md text-faded" }, [
                          _vm._v(_vm._s(_vm.$t("quotes_empty")))
                        ]),
                        _c(
                          "q-btn",
                          {
                            directives: [
                              { name: "is-user", rawName: "v-is-user" }
                            ],
                            staticClass: "q-mt-lg",
                            attrs: { color: "primary", outline: "" },
                            on: { click: _vm.handleCreateQuote }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("create_quote")) +
                                "\n          "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ]
                )
              ]
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }